import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Training } from './training.model';
import { JhiLanguageHelper } from '../../shared';
import { TrainingPrice } from './location/price.model';

@Injectable()
export class TrainingService {
    constructor(
        private http: HttpClient,
        private languageHelper: JhiLanguageHelper
    ) {}

    findAll(language?: string): Observable<Training[]> {
        if (!language) {
            language = this.languageHelper.getCurrentLang();
        }
        return this.http.get<Training[]>('/api/trainings?language=' + language);
    }

    search(
        keyword: string,
        {
            language,
            activeOnly = false,
        }: { language?: string; activeOnly?: boolean } = {}
    ): Observable<Training[]> {
        if (!language) {
            language = this.languageHelper.getCurrentLang();
        }
        return this.http.get<Training[]>(
            `/api/trainings/search?language=${language}&keyword=${keyword}&activeOnly=${activeOnly}`
        );
    }

    findById(
        trainingId: number | string,
        metadata: boolean,
        language?: string
    ): Observable<Training> {
        if (!language) {
            language = this.languageHelper.getCurrentLang();
        }

        const parameters = [];

        if (metadata) {
            parameters.push('metadata=true');
        }
        if (language) {
            parameters.push('language=' + language);
        }

        return this.http.get<Training>(
            '/api/trainings/' + trainingId + this.buildParameters(parameters)
        );
    }

    update(training): Observable<Training[]> {
        return this.http.put<Training[]>(
            '/api/trainings/' + training.id,
            training
        );
    }

    create(training): Observable<Training> {
        return this.http.post<Training>('/api/trainings', training);
    }

    getUniverses(): Observable<any[]> {
        return this.http.get<any[]>('/api/universes');
    }

    getPartners(): Observable<any[]> {
        return this.http.get<any[]>('/api/partners');
    }

    resetPicture(trainingId) {
        return this.http.delete('/api/trainings/' + trainingId + '/picture');
    }

    uploadPicture(trainingId, file) {
        let formData = new FormData();
        formData.append('file', file);
        return this.http.post(
            '/api/trainings/' + trainingId + '/picture',
            formData
        );
    }

    updateFullTraining(training: Training): Observable<any> {
        return this.http.put<any>('/api/trainings/full', training);
    }

    findTrainingFull(trainingId: number): Observable<any> {
        return this.http.get<any>('api/trainings/' + trainingId + '/full');
    }

    private buildParameters(parameters: string[]): string {
        if (parameters.length === 0) {
            return '';
        }
        return '?' + parameters.join('&');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/training/training.service.ts